import {combineReducers} from 'redux';
import {areasReducer} from './areas/reducer';
import {buildingsReducer} from './buildings/reducer';
import {floorsReducer} from './floors/reducer';
import {connectionsReducer} from './connections/reducer';
import {featuresReducer} from '../infrastructure/features/reducer';
import {openingDaysReducer} from './openingDays/reducer';
import {checkInReducer} from './checkIn/reducer';
import {meetingRoomReducer} from './meetingRooms/reducer';
import {userReducer} from './user/reducer';
import {profilesReducer} from './profiles/reducer';
import {calendarReducer} from './calendar/reducer';
import {settingsReducer} from './settings/reducer';
import {workspaceReservationsReducer} from './workspaceReservation/reducer';

import {desksReducer} from './desks';
import {notificationsReducer} from './notifications';
import {meetingsReducer} from './meetings';
import {parkingLotsReducer} from './parkingLot';
import {parkingReservationReducer} from './parkingReservation';
import {workdayReducer} from './workday';
import {extrasReducer} from './extras';
import {typologyReducer} from './typology';
import {sensorsReducer} from './sensors';
import {buildingResourcesReducer} from './buildingResources';
import {customerBrandingReducer} from './customerBranding';
import {onboardingReducer} from './onboarding';
import {preferencesReducer} from './preferences';
import {employeeCommunicationReducer} from './employeeCommunication';
import {controlsReducer} from './controls';
import {timeslotsSlice} from './timeslots';

export const dataReducer = combineReducers({
  workspaceReservations: workspaceReservationsReducer,
  buildings: buildingsReducer,
  floors: floorsReducer,
  areas: areasReducer,
  desks: desksReducer,
  settings: settingsReducer,
  connections: connectionsReducer,
  notification: notificationsReducer,
  onboarding: onboardingReducer,
  features: featuresReducer,
  meetings: meetingsReducer,
  openingDays: openingDaysReducer,
  checkIn: checkInReducer,
  meetingRooms: meetingRoomReducer,
  user: userReducer,
  preferences: preferencesReducer,
  profiles: profilesReducer,
  calendar: calendarReducer,
  parkingLots: parkingLotsReducer,
  parkingReservation: parkingReservationReducer,
  workday: workdayReducer,
  extras: extrasReducer,
  typology: typologyReducer,
  sensors: sensorsReducer,
  buildingResources: buildingResourcesReducer,
  customerBranding: customerBrandingReducer,
  employeeCommunication: employeeCommunicationReducer,
  controls: controlsReducer,
  timeslots: timeslotsSlice.reducer,
});
